var _defs, _circle, _path, _path2, _path3, _g, _g2, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _path8, _g6, _path9, _path0, _path1, _path10, _path11, _path12, _g7, _path13, _path14, _g8, _path15, _g9, _path16, _g0, _g1, _g10, _g11, _g12, _g13, _path17, _g14, _path18, _g15, _g16, _g17, _g18, _g19, _g20, _path19, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork_7",
    "data-name": "Artwork 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.545,
    height: 74.545,
    viewBox: "0 0 74.545 74.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 41.534,
    height: 65.722,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 15.972,
    height: 8.99,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 8.967,
    height: 5.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 10.712,
    height: 8.78,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 13.9,
    height: 6.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 12.143,
    height: 6.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 2.33,
    height: 0.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 0.97,
    height: 7.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 5.111,
    height: 16.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 4.112,
    height: 2.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 7.084,
    height: 4.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 0.99,
    height: 0.843,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 12.349,
    height: 14.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1.859,
    height: 0.634,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 3.98,
    height: 2.927,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 3.852,
    height: 3.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 6.558,
    height: 5.451,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 24.425,
    height: 19.244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 27.883,
    height: 5.118,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 0.853,
    height: 0.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 40.234,
    height: 13.093,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 18.043,
    height: 5.172,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 10.811,
    height: 5.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 0.705,
    height: 6.794,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u05D0\\u05D5\\u05D5\\u05D8\\u05E8-1-01",
    cx: 37.273,
    cy: 37.273,
    r: 37.273,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670",
    transform: "translate(16.506 2.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M244.784,781.1c.512-.085,3.838,8.956-2.132,11.941s5.459,8.614,5.459,8.614l13.561-5.032-3.07-3.156s-9.041-2.985-3.07-10.15-10.747-2.218-10.747-2.218",
    transform: "translate(-230.009 -744.122)",
    fill: "#a67c52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M21.246,26.4c-.256.085-13.647,4.947-8.444-.768s2.388-4.947,7.847-9.808c0,0,1.706-4.179,1.109-5.459A2.681,2.681,0,0,1,22.184,7.3,16.212,16.212,0,0,1,31.907.56c6.567-1.791,7.762,1.194,7.591,2.3S42.654,4.91,43,5.848s2.388,2.729,2.473,4.009c0,0,14.67,3.582,1.962,8.87A142.484,142.484,0,0,1,21.246,26.4",
    transform: "translate(-11.077 -0.001)",
    fill: "#ffd36a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M743.315,523.41s2.644-1.109,2.729,0,1.365,4.094-2.729,2.644,0-2.644,0-2.644",
    transform: "translate(-707.9 -499.225)",
    fill: "#a67c52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(0.6 19.422)",
    opacity: 0.88,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M13.238,437.188c.881,1.6,9.366-1.483,9.569-1.551,0,0,1.387-.246,3.691-.754l2.706-5.728s.512-2.3-8.359,2.985c-5.018,2.992-7.5,4.154-7.608,5.048",
    transform: "translate(-13.238 -428.657)",
    fill: "#2a1e17"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603",
    transform: "translate(32.515 14.142)",
    opacity: 0.88,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M722.939,312.441c-1.791-.768-5.288.085-5.288.085l1.461,5.133q1.19-.46,2.377-.953c3.415-1.421,4.853-2.719,5.129-3.857-.2-1.306-1.758.416-3.679-.407",
    transform: "translate(-717.651 -312.121)",
    fill: "#2a1e17"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(14.809 36.986)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M336.012,825.085c-.814-1.594-.771-3.754,1.56-6.551l-10.712-2.21c.317.141,1.3,2.583,1.348,5.3,1.221,1.967,3.513,3.677,7.8,3.457",
    transform: "translate(-326.86 -816.324)",
    fill: "#534741"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M747.73,337.831a.582.582,0,0,1,0-.423c.148-.381.036-.568-.138-.658a.586.586,0,0,1-.326-.607,1.012,1.012,0,0,0-.162-.726.569.569,0,0,1-.072-.447c.1-.4-.014-.59-.157-.682-.166-.107.254-.291.247-.489a.41.41,0,0,0-.189-.351.565.565,0,0,1-.253-.522.819.819,0,0,0-.286-.826c.123-.372.051-.763-.3-.879,0,0,.6-.6-.256-1.023,0,0,.3-1.231-1-.957l.321,2.236a5.292,5.292,0,0,0,.236.572c-2.677.077-2.332,2.7-2.287,2.986,0,.017,0,.035.006.052l.4,5.637a.58.58,0,0,0,.286.46l1.782,1.04c.341.114.455-.227.493-.468a.521.521,0,0,1,.169-.308.481.481,0,0,0,.126-.474.576.576,0,0,1,.194-.563,1.137,1.137,0,0,0,.318-.506.578.578,0,0,1,.295-.331c.316-.151-.085-.331-.06-.486a.544.544,0,0,1,.36-.425c.438-.159.357-.576.257-.832",
    transform: "translate(-709.398 -314.286)",
    fill: "#2a1e17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609",
    transform: "translate(20.575 5.555)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M454.293,255.892l-.187.053.187-.053",
    transform: "translate(-454.105 -249.853)",
    fill: "#ffee90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M471.956,126.933l-.083-.021c-.085-1.279-2.132-3.07-2.473-4.009a.877.877,0,0,0-.2-.292c.765,2.557-9.443,5.6-10.96,6.039,6.17-1.76,10.577-2.08,13.713-1.717",
    transform: "translate(-458.056 -122.611)",
    fill: "#ffee90"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M472.121,67.49c1.2-.126,5.132.027,6.393-.6-.672-.4-1.263-.807-1.354-1.244a9.791,9.791,0,0,0-5.721.824c-2.729,1.621-.938,1.194.682,1.024",
    transform: "translate(-448.732 -62.581)",
    fill: "#ffee90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(8.688 10.142)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M195.023,224.066a1.158,1.158,0,0,1-1.324-.1c.015.033.029.067.045.1.6,1.279-1.109,5.459-1.109,5.459-.323.288-.616.555-.884.805a75.3,75.3,0,0,1,12.143-5.838c-1.535.6-6.738-1.279-8.87-.426",
    transform: "translate(-191.751 -223.839)",
    fill: "#534741"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M143.808,313.545s2.388,1.45.853,8.956,4.776,4.094-.853,12.452-8.1,7.847-11.088,6.653c-3.035-1.214-14.67-1.023-13.647-14.67,0,0-3.156,3.582-4.691-.853s5.459-1.876,5.459-1.876l1.279-4.094a90.77,90.77,0,0,1,22.687-6.567",
    transform: "translate(-108.99 -299.339)",
    fill: "#a67c52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M457.107,716.4a10.2,10.2,0,0,0,8.073.7s-.446,1.116-.885,2.056c-.287.614-4.04,1.979-7.188-2.754",
    transform: "translate(-436.396 -683.938)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M466.326,721.477a5.585,5.585,0,0,0,6.269,2.093c.524-.1.843-1.08.958-1.508a10.489,10.489,0,0,1-7.227-.585",
    transform: "translate(-445.198 -688.788)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(24.751 30.166)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M546.453,666.474c-.972,0,2.473-.938,2.132-.6s-.256.6-2.132.6",
    transform: "translate(-546.28 -665.802)",
    fill: "#534741"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M439.979,557.464c.063.324-.336.673-.891.781s-1.056-.067-1.119-.391.336-.673.891-.781,1.056.067,1.119.391",
    transform: "translate(-418.12 -531.803)",
    fill: "#2a1e17"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M633.277,551.464c-.063.324.336.674.891.781s1.056-.067,1.119-.391-.336-.674-.891-.781-1.056.067-1.118.391",
    transform: "translate(-604.578 -526.074)",
    fill: "#2a1e17"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M416.455,550.75a7.1,7.1,0,0,1,4.606-1.109,17.307,17.307,0,0,0-4.606,1.109",
    transform: "translate(-397.586 -524.689)",
    fill: "#2a1e17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M625.41,543.207a6.832,6.832,0,0,1,3.753,1.45,17,17,0,0,0-3.753-1.45",
    transform: "translate(-597.074 -518.595)",
    fill: "#2a1e17"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M388.456,317.717c.094-.206.612.725,1.168.278a.217.217,0,0,1,.225-.032.355.355,0,0,0,.318,0,.215.215,0,0,1,.3.1.418.418,0,0,0,.38.26.227.227,0,0,1,.2.156.42.42,0,0,0,.466.3.222.222,0,0,1,.22.14.3.3,0,0,0,.332.2.228.228,0,0,1,.213.1.3.3,0,0,0,.377.135.222.222,0,0,1,.237.044.316.316,0,0,0,.294.074.207.207,0,0,1,.2.076.186.186,0,0,0,.26.05.221.221,0,0,1,.222,0,.63.63,0,0,0,.838-.087.23.23,0,0,1,.157-.079.417.417,0,0,0,.427-.44.222.222,0,0,1,.131-.192.266.266,0,0,0,.157-.262.22.22,0,0,1,.172-.22.254.254,0,0,0,.209-.156.228.228,0,0,1,.19-.161.246.246,0,0,0,.215-.139.223.223,0,0,1,.25-.123.194.194,0,0,0,.157-.034.222.222,0,0,1,.252-.009.21.21,0,0,0,.1.038.225.225,0,0,1,.209.169.212.212,0,0,0,.107.158.232.232,0,0,1,.142.185.338.338,0,0,0,.225.316.228.228,0,0,1,.152.127.282.282,0,0,0,.414.179.22.22,0,0,1,.135-.016.51.51,0,0,0,.529-.144.238.238,0,0,1,.31-.076.222.222,0,0,0,.114.032s.283.283.463-.053a.22.22,0,0,1,.168-.116.264.264,0,0,0,.253-.232.223.223,0,0,1,.223-.184c.082,0,.165-.046.218-.185a.223.223,0,0,1,.2-.145.327.327,0,0,0,.336-.3.232.232,0,0,1,.153-.174.29.29,0,0,0,.207-.234.22.22,0,0,1,.172-.177.513.513,0,0,0,.4-.445.222.222,0,0,1,.219-.179c.128,0,.277-.064.308-.356a.224.224,0,0,1,.1-.16.2.2,0,0,0,.082-.105.233.233,0,0,1,.2-.166.315.315,0,0,0,.146-.05.222.222,0,0,1,.183-.024c.2.059.592.114.5-.443a.219.219,0,0,1,.25-.251c.183.025.355-.028.277-.355a.227.227,0,0,1,.028-.176c.118-.184.316-.691-.568-.775-1.791-.171-12.7,2.277-17.7,4.339a.222.222,0,0,0,.144.419.525.525,0,0,0,.123-.059.229.229,0,0,1,.243-.006.491.491,0,0,0,.6.017.222.222,0,0,1,.293-.012c.186.151.5.256.772-.35",
    transform: "translate(-368.649 -299.161)",
    fill: "#2a1e17"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M173.551,432.154a.444.444,0,0,1,.019.509.455.455,0,0,0-.006.5.721.721,0,0,1-.082.9.46.46,0,0,0-.084.405.629.629,0,0,1-.364.753.47.47,0,0,0-.235.463.491.491,0,0,1-.2.484.476.476,0,0,0-.2.51.508.508,0,0,1-.011.333.452.452,0,0,0,.084.464.654.654,0,0,1,.033.885.448.448,0,0,0-.075.161.955.955,0,0,1-.434.643.458.458,0,0,0-.232.57.569.569,0,0,1,.008.486.44.44,0,0,0-.068.272c.021.329-.022.953-.7.734a.466.466,0,0,0-.335.015.766.766,0,0,1-1.063-.222.472.472,0,0,0-.2-.186c-.35-.182-1.216-.717-.991-1.449a.458.458,0,0,0-.213-.524.651.651,0,0,1-.358-.527.463.463,0,0,0-.454-.445c-.463-.011-1-.165-.938-.842a.464.464,0,0,0-.411-.508l-.022,0a.465.465,0,0,1-.209-.851A35.175,35.175,0,0,1,173,431.966a.464.464,0,0,1,.55.188",
    transform: "translate(-158.104 -412.369)",
    fill: "#2a1e17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    transform: "translate(26.267 22.82)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M580.225,510.626c-1.219.244.213-6.951.213-6.951a30.313,30.313,0,0,0-.256,6.482c.085.426.6.256.512.768,0,0-.256-.341-.469-.3",
    transform: "translate(-579.733 -503.675)",
    fill: "#fff"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M447.555,564.934a.178.178,0,1,1-.207-.051.154.154,0,0,1,.207.051",
    transform: "translate(-426.97 -539.273)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M646.6,555.234c-.012.046-.1.064-.186.04s-.156-.079-.144-.125.1-.064.186-.04.156.079.144.125",
    transform: "translate(-616.985 -529.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(32.092 22.356)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M711.885,494.235c.057-.277.107-.545.154-.805-.013.034-1.345,3.627-.751,5.07s1.535,5.631-2.982,11.853a42.116,42.116,0,0,0,2.726-3.665c5.629-8.358-.682-4.947.853-12.452",
    transform: "translate(-708.306 -493.43)",
    fill: "#fff"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M12.073,1086.929s15.325,10.078,16.348.014c0,0,9.979,2.9,10.32,3.753s2.473,11.429,2.473,11.429L14.263,1103.4l-13.732-4.52s-4.295-3.611,11.542-11.955",
    transform: "translate(0 -1037.682)",
    fill: "#f15a24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(23.121 36.44)",
    opacity: 0.44,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M510.593,804.686c.022-1.242,2.431.821,3.834-.187,0,0-.571.54-.169,1.8,0,0-2.485-1.929-3.944-.321,0,0,.256-.012.279-1.294",
    transform: "translate(-510.314 -804.274)",
    fill: "#534741"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M782.172,240.87c1.4,2.28,2.559,4.094,3.412,3.07s-4.094-4.179-3.412-3.07",
    transform: "translate(-746.671 -229.734)",
    fill: "#ffee90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627",
    transform: "translate(17.126 21.56)",
    opacity: 0.43,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M384.335,479.252s1.535-2.047.171-2.985-4.654-.116-5.653,1.051-1.6,4.664.877,3.043a17.061,17.061,0,0,1,4.606-1.109",
    transform: "translate(-377.986 -475.859)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(9.093 27.597)",
    opacity: 0.44,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M201.689,609.094l-.99.843a5.443,5.443,0,0,0,.99-.843",
    transform: "translate(-200.699 -609.094)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(10.02 27.597)",
    opacity: 0.44,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M233.507,623.377c-11.233-2.884-12.286-14.283-12.286-14.283-.905,12.073,8.1,13.316,12.286,14.283",
    transform: "translate(-221.158 -609.094)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(22.887 42.005)",
    opacity: 0.44,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M505.568,927.188c-.141-.029-.279-.06-.416-.091a7.09,7.09,0,0,1,.843.262c.344.137.68.266,1.016.372a3.33,3.33,0,0,0-1.442-.543",
    transform: "translate(-505.152 -927.096)",
    fill: "#534741"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639",
    transform: "translate(29.632 28.337)",
    opacity: 0.37,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M654.431,625.713c-1.912.556,3.5.085,3.412,2.644,0,0,1.279-4.009-3.412-2.644",
    transform: "translate(-654.022 -625.43)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(17.699 27.993)",
    opacity: 0.37,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M391.562,617.949c-3.115.8,2.729,1.279,2.815,2.729s.853-3.667-2.815-2.729",
    transform: "translate(-390.649 -617.834)",
    fill: "#fff"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M397.205,470.876c-.341.682.171.256.768,0a7.626,7.626,0,0,1,2.3-.6c.256.085,1.621-.6.426-.768s-3.5,1.365-3.5,1.365",
    transform: "translate(-379.104 -448.226)",
    fill: "#2a1e17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(26.715 21.207)",
    opacity: 0.43,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M594.852,469.215a3.784,3.784,0,0,1,1.1,4.3s-3.07-2.388-6.311-2.047c0,0,0-4.009,2.473-3.326s2.736,1.071,2.736,1.071",
    transform: "translate(-589.643 -468.065)",
    fill: "#534741"
  }))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M636.335,462.155c-.835-.088-.682,1.023.171.938a4.5,4.5,0,0,1,2.559.853c.171.256.341-.341-.426-.768s-.682-.853-2.3-1.023",
    transform: "translate(-606.975 -441.211)",
    fill: "#2a1e17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(0.526 9.168)",
    opacity: 0.43,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M17.834,213.871c.085-2.388,5.168-5.9,5.168-5.9-.2-.863.887-1.1,1.484-2.548s-.426-2.047-2.132-2.388a1.134,1.134,0,0,1-.9-.688,2.941,2.941,0,0,0,.307,1.2c.6,1.279-1.109,5.459-1.109,5.459-5.459,4.862-2.644,4.094-7.847,9.808s8.188.853,8.444.768c0,0,1.211-5.205,4.179-5.885l10.6-4.3c-10.379,2.016-18.278,6.854-18.193,4.466",
    transform: "translate(-11.603 -202.351)",
    fill: "#534741"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(12.728 9.77)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M308.8,218.558s-4.939-4.124-10.568-2.589-5.715-.171-17.314,4.776c0,0,18.322-6.166,27.883-2.188",
    transform: "translate(-280.916 -215.627)",
    fill: "#ffee90"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(25.692 36.296)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M567.906,801.234c0,.071-.191.128-.426.128s-.427-.057-.427-.128.191-.128.427-.128.426.057.426.128",
    transform: "translate(-567.053 -801.106)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(1.14 13.565)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M25.17,585.064l.221-.158,0,0Z",
    transform: "translate(-25.17 -571.971)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M34.959,578.174l.223-.156.009.014-.226.151Z",
    transform: "translate(-34.515 -565.395)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M44.812,571.363l.224-.154.015.023-.227.149Z",
    transform: "translate(-43.922 -558.894)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M54.727,564.653l.226-.151.02.03-.228.148Z",
    transform: "translate(-53.387 -552.49)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M64.711,558.032l.227-.149.024.037-.229.146Z",
    transform: "translate(-62.919 -546.172)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M74.754,551.511l.229-.147.028.044-.231.143Z",
    transform: "translate(-72.507 -539.948)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M84.869,545.1l.231-.144.031.051-.232.141Z",
    transform: "translate(-82.164 -533.834)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M95.075,538.841l.233-.141.035.059-.235.137Z",
    transform: "translate(-91.908 -527.858)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M105.39,532.772l.236-.136.037.067-.237.132Z",
    transform: "translate(-101.755 -522.069)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M115.842,526.976l.24-.129.039.075-.241.125Z",
    transform: "translate(-111.734 -516.542)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M126.5,521.624l.246-.117.038.084-.246.113Z",
    transform: "translate(-121.909 -511.443)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M137.249,516.066l.235-.133.049.083-.24.132Z",
    transform: "translate(-132.171 -506.122)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M147.517,509.715l.227-.147.056.085-.23.146Z",
    transform: "translate(-141.974 -500.046)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M157.5,502.994l.224-.154.06.088-.226.152Z",
    transform: "translate(-151.5 -493.623)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M167.346,496.128l.222-.156.064.092-.224.154Z",
    transform: "translate(-160.904 -487.066)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M177.165,489.245l.223-.156.066.1-.224.154Z",
    transform: "translate(-170.278 -480.495)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M187.013,482.421l.224-.154.068.1-.225.152Z",
    transform: "translate(-179.68 -473.981)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M196.933,475.705l.226-.151.07.106-.227.149Z",
    transform: "translate(-189.151 -467.573)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M206.947,469.139l.229-.148.07.111-.229.145Z",
    transform: "translate(-198.711 -461.307)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M217.069,462.741l.231-.144.071.117-.232.141Z",
    transform: "translate(-208.374 -455.203)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M227.309,456.53l.234-.139.071.122-.234.137Z",
    transform: "translate(-218.151 -449.278)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M237.667,450.521l.237-.135.071.128-.237.132Z",
    transform: "translate(-228.04 -443.545)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M248.145,444.717l.239-.13.071.134-.239.127Z",
    transform: "translate(-238.042 -438.009)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M258.745,439.148l.242-.125.069.137-.241.123Z",
    transform: "translate(-248.162 -432.698)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M269.474,433.807l.245-.12.067.14-.244.118Z",
    transform: "translate(-258.405 -427.603)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M280.313,428.685l.247-.115.065.143-.246.113Z",
    transform: "translate(-268.753 -422.718)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M291.248,423.782l.249-.11.063.146-.248.108Z",
    transform: "translate(-279.193 -418.042)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M302.284,419.1l.252-.1.061.149-.25.1Z",
    transform: "translate(-289.729 -413.574)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M313.413,414.626l.254-.1.059.151-.253.1Z",
    transform: "translate(-300.354 -409.31)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M324.629,410.369l.255-.1.056.154-.254.094Z",
    transform: "translate(-311.061 -405.25)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M335.922,406.322l.257-.09.054.157-.256.089Z",
    transform: "translate(-321.843 -401.392)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M347.291,402.481l.259-.086.052.159-.258.085Z",
    transform: "translate(-332.696 -397.729)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M358.7,398.76l.258-.084.052.161-.259.084Z",
    transform: "translate(-343.593 -394.178)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M370.1,395.024l.258-.085.053.162-.259.084Z",
    transform: "translate(-354.476 -390.61)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M381.5,391.28l.258-.085.053.164-.258.084Z",
    transform: "translate(-365.358 -387.036)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M392.9,387.536l.258-.085.054.165-.258.084Z",
    transform: "translate(-376.234 -383.462)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M404.294,383.8l.258-.085.054.167-.259.084Z",
    transform: "translate(-387.117 -379.893)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M415.7,380.069l.258-.084.055.168-.259.083Z",
    transform: "translate(-398.005 -376.334)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M427.107,376.361l.259-.084.055.17-.259.083Z",
    transform: "translate(-408.896 -372.794)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M438.523,372.674l.259-.083.055.172-.259.083Z",
    transform: "translate(-419.795 -369.274)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M449.951,369.027l.259-.082.055.172-.259.083Z",
    transform: "translate(-430.705 -365.794)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M461.4,365.431l.26-.081.054.171-.259.082Z",
    transform: "translate(-441.635 -362.361)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M472.859,361.869l.26-.081.053.169-.259.081Z",
    transform: "translate(-452.575 -358.962)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M484.331,358.347l.26-.08.051.168-.26.08Z",
    transform: "translate(-463.527 -355.6)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M495.815,354.867l.26-.079.05.166-.26.079Z",
    transform: "translate(-474.492 -352.279)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M507.314,351.435l.261-.077.049.165-.26.078Z",
    transform: "translate(-485.469 -349.003)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M518.828,348.053l.261-.076.048.164-.261.077Z",
    transform: "translate(-496.462 -345.776)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M530.359,344.726l.262-.075.047.162-.261.076Z",
    transform: "translate(-507.47 -342.601)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M541.906,341.459l.262-.074.045.161-.261.074Z",
    transform: "translate(-518.494 -339.483)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M553.472,338.254l.262-.072.044.16-.262.073Z",
    transform: "translate(-529.536 -336.425)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M565.057,335.119l.263-.071.043.158-.262.071Z",
    transform: "translate(-540.596 -333.433)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M576.662,332.056l.263-.069.041.157-.263.07Z",
    transform: "translate(-551.675 -330.511)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M588.288,329.073l.264-.067.04.156-.263.068Z",
    transform: "translate(-562.775 -327.664)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M599.937,326.175l.264-.065.038.154-.263.066Z",
    transform: "translate(-573.895 -324.9)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M611.608,323.366l.265-.063.036.153-.264.064Z",
    transform: "translate(-585.037 -322.22)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M623.3,320.655l.265-.061.035.152-.265.061Z",
    transform: "translate(-596.202 -319.634)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M635.022,318.049l.266-.058.033.15-.265.059Z",
    transform: "translate(-607.391 -317.148)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M646.767,315.566l.267-.055.031.148-.266.057Z",
    transform: "translate(-618.604 -314.781)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M658.544,313.23l.267-.052.028.143-.266.054Z",
    transform: "translate(-629.848 -312.553)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M670.349,311.025l.268-.049.026.139-.267.051Z",
    transform: "translate(-641.117 -310.451)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M682.18,308.962l.269-.046.023.134-.267.048Z",
    transform: "translate(-652.413 -308.485)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M694.039,307.054l.269-.042.021.13-.268.045Z",
    transform: "translate(-663.734 -306.667)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M705.924,305.314l.27-.038.018.125-.268.041Z",
    transform: "translate(-675.08 -305.01)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M717.836,303.758l.27-.034.015.12-.269.036Z",
    transform: "translate(-686.452 -303.528)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M729.774,302.4l.271-.029.013.116-.27.032Z",
    transform: "translate(-697.85 -302.238)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M741.737,301.267l.271-.024.01.111-.27.027Z",
    transform: "translate(-709.271 -301.159)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M753.723,300.377l.272-.019.007.106-.271.021Z",
    transform: "translate(-720.714 -300.315)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M765.73,299.757l.272-.012,0,.1-.271.015Z",
    transform: "translate(-732.176 -299.729)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M777.752,299.439l.272-.005,0,.1-.271.008Z",
    transform: "translate(-743.654 -299.432)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M789.784,299.4l.273,0v.091h-.271Z",
    transform: "translate(-755.141 -299.403)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M801.761,299.628l.272.012,0,.083-.271-.008Z",
    transform: "translate(-766.573 -299.618)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M813.722,300.281l.272.022-.006.075-.271-.018Z",
    transform: "translate(-777.99 -300.241)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M825.549,301.706l.266.064-.017.065-.263-.059Z",
    transform: "translate(-789.272 -301.602)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M837.158,304.706l.262.07-.014.057-.264-.067Z",
    transform: "translate(-800.352 -304.465)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M848.878,307.582l.266.044-.006.05-.271-.04Z",
    transform: "translate(-811.548 -307.212)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M860.862,309.1l.27,0v.043h-.273Z",
    transform: "translate(-822.996 -308.659)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M872.828,308.217l.269-.032.005.034-.27.036Z",
    transform: "translate(-834.423 -307.787)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M884.649,305.877l.264-.06.006.025-.265.065Z",
    transform: "translate(-845.708 -305.526)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M896.339,304.134a1.267,1.267,0,0,1,.273-.011v.014a1.256,1.256,0,0,0-.269.016Z",
    transform: "translate(-856.868 -303.906)",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M908.159,305.521a.662.662,0,0,1,.225.152l0,0a.655.655,0,0,0-.225-.146Z",
    transform: "translate(-868.15 -305.244)",
    fill: "#f15a24"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(11.266 49.916)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M249.784,1103.363s16.611,11.264,17.9,0",
    transform: "translate(-249.733 -1103.288)",
    fill: "none",
    stroke: "#f15a24",
    strokeWidth: 4,
    strokeDasharray: "6 6"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(28.414 49.261)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M637.932,1092.928c-.225-1-.4-1.734-.483-1.934-.341-.853-10.32-3.753-10.32-3.753,0,.023-.005.045-.008.068a11.611,11.611,0,0,0,2.853,1.985c1.89.959,5.308,1.62,7.958,3.633",
    transform: "translate(-627.121 -1087.242)",
    fill: "#ffee90"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M611.637,733.249a2.683,2.683,0,0,1,.082.742.454.454,0,0,0,.1-.132c.439-.94.885-2.056.885-2.056q-.213.062-.422.115a4.186,4.186,0,0,1-.649,1.331",
    transform: "translate(-583.925 -698.647)",
    fill: "#8c6239"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(26.267 22.82)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M580.333,504.531c.06-.526.107-.856.107-.856s-1.144,5.745-.517,6.794a23.581,23.581,0,0,1,.41-5.938",
    transform: "translate(-579.735 -503.675)",
    fill: "#fff"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.9b0af9125171c98e8b03640f7294731c.svg";
export { ForwardRef as ReactComponent };